import { render, staticRenderFns } from "./baseInfo-edit.vue?vue&type=template&id=607b48f2&"
import script from "./baseInfo-edit.vue?vue&type=script&lang=js&"
export * from "./baseInfo-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports